<template>
	<div>
		<v-dialog v-model="dialog_tds" v-if="dialog_tds" no-click-animation persistent scrollable content-class="full-height" lazy transition="dialog-bottom-transition">
	        <v-card>
	        	<v-card-title noshadow>Apply TDS</v-card-title>
	        	<v-divider></v-divider>
		        <v-card-text full-height nopadding>
		            <v-layout wrap>

		            	<v-form data-vv-scope="fields" full-width padding-all-16>

		            		<v-flex xs12 sm12 md12 @click="fn_openAccounts">
				               <v-text-field  
					               	readonly
					               	v-model="$parent.Form.tdsDataModel.tdsAccountName" 
					               	label="Select Ledger"
					               	:onUpdate="fn_updateTdsAccount" 
					               	placeholder=" " 
					               	append-icon="arrow_drop_down"
					               	ref="ref_dialogTds_AccountLedger"
					               	v-validate="'required'" 
				               		data-vv-name="accounts" 
				               		:error-messages="errors.collect('fields.accounts')"
				               		required>
				               </v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12>
				               <v-text-field  
					               	type="number"
					               	v-model.number="$parent.Form.tdsDataModel.appliedOnAmount" 
					               	label="TDS Applied On Value"
					               	prefix="₹"
					               	placeholder=" "
					               	v-validate="'required|decimal:2'" 
					               	:error-messages="errors.collect('fields.applicableValue')" 
					               	data-vv-name="applicableValue"
					               	required>
				               </v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12>
				               <v-text-field  
				               		type="number"
					               	v-model.number="$parent.Form.tdsDataModel.percentage" 
					               	label="TDS Percentage (%)"
					               	placeholder=" "
					               	v-validate="'required|max_value:100|decimal:2'" 
					               	:error-messages="errors.collect('fields.percentage')" 
					               	data-vv-name="percentage"
					               	required>
				               </v-text-field>
				            </v-flex>

				            <v-flex xs12 sm12 md12>
				               <v-text-field 
				               		disabled
				               		type="number" 
					               	v-model.number="tdsAmount" 
					               	label="TDS Amount"
					               	placeholder=" " >
				               </v-text-field>
				            </v-flex>

			            </v-form>

		            </v-layout>
		        </v-card-text>
		        <v-divider></v-divider>
		        <v-card-actions>
		        	<v-spacer></v-spacer>
		        	<v-btn small color="blue darken-1" flat @click="deleteTds" v-if="$parent.Form.tdsDataModel.transactionTdsId">delete</v-btn>
          			<v-btn small color="blue darken-1" flat @click="$parent.fn_closeDialog">close</v-btn>
		          	<v-btn small color="blue darken-1" flat @click="fn_checkValidations">ok</v-btn>
		        </v-card-actions>
		    </v-card>

		    

	    </v-dialog>
	</div>
</template>

<script>
export default{
	props:['openAccountLedgers', 'saveTdsDetails', 'deleteTds'],
	data(){
		return{
			dialog_tds:false,
			// tdsData:{"accountLedgerId":null, "accountLedgerName":null, "appliedOn":null, "percentage":null, "amount":null}
		}
	},
	methods:{
		openDialogWeb: function () {
			// if(this.tdsDetails){
			// 	this.tdsData = JSON.parse(JSON.stringify(this.tdsDetails))
			// }
			// else{
			// 	this.tdsData = {"accountLedgerId":null, "accountLedgerName":null, "appliedOn":null, "percentage":null, "amount":null};
			// }
			this.$validator.reset();
			this.dialog_tds = true;
		},
		closeDialogWeb: function () {
			this.dialog_tds = false;
		},
		fn_openAccounts: function () {
			let accountGroups = [];
			let tdsGroupId = "6c92acb9-0ad2-42f4-bbda-d3a9e33972d4";
			accountGroups.push(tdsGroupId);
			this.openAccountLedgers('android', 'TdsAccounts', 'ref_dialogTds_AccountLedger', this.$parent.Form.tdsDataModel.tdsAccountId, this.$parent.Form.tdsDataModel.tdsAccountName, accountGroups)
		},
		fn_updateTdsAccount: function (selectedValueId, selectedValueName, isRemoved) {
			if(!isRemoved){
				this.$parent.Form.tdsDataModel.tdsAccountId = selectedValueId;
	        	this.$parent.Form.tdsDataModel.tdsAccountName = selectedValueName;
			}
			else{
				this.$parent.Form.tdsDataModel.tdsAccountId = null;
	        	this.$parent.Form.tdsDataModel.tdsAccountName = null;
			}
			this.$forceUpdate();
		},
		fn_checkValidations: function () {
			let self = this;
			this.$validator.validateAll('fields').then((result) => {
		        if(result){
		        	self.$parent.Form.tdsDataModel.amount = self.tdsAmount;
		        	self.saveTdsDetails(self.$parent.Form.tdsDataModel);
		        }
		    });
		}
	},
	computed:{
		tdsAmount: function () {
			let amount = 0;
			amount = (this.$parent.Form.tdsDataModel.appliedOnAmount * this.$parent.Form.tdsDataModel.percentage) / 100;
			return this.roundUpto2Decimals(amount);
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/transactions/forms/dialogs/dialog_tds.vue